(() => {
  const root = document.querySelector('[data-de-recommendation]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const data = window.TcDeRecommendationData;
  if (!data) { root.dataset.ready='false'; return; }
  let queryRevision=0,queryController=null,catalogueController=null;
  const salesWindow=JSON.parse(root.querySelector('[data-sales-window]').textContent);
  const isCoverageRowForNeed=data.isForNeed;
  const isCoverageRowAllowedForProduct=data.rowAllowed;
  const rawProducts = JSON.parse(root.querySelector('[data-product-json]').textContent)
    .filter(product => product.shopifyProductId);
  const products=rawProducts.slice().sort((a,b)=>a.salesRank-b.salesRank);
  const salesOrder=products.map(p=>p.apiName);
  const modeButtons = [...root.querySelectorAll('[data-mode]')];
  const needsSection = root.querySelector('[data-needs-section]');
  const needButtons = [...root.querySelectorAll('[data-need]')];
  const scannerBlock = root.querySelector('[data-scanner-block]');
  const scannersWrap = root.querySelector('[data-scanners]');
  const makeSelect = root.querySelector('[data-make]');
  const modelSelect = root.querySelector('[data-model]');
  const yearSelect = root.querySelector('[data-year]');
  const form = root.querySelector('.tcv__form');
  const submit = form.querySelector('[type="submit"]');
  const submitLabel = form.querySelector('[data-submit-label]');
  const demoButton = form.querySelector('[data-demo]');
  demoButton.disabled=true;
  const status = root.querySelector('[data-status]');
  const results = root.querySelector('[data-results]');
  const supportButtons = [...root.querySelectorAll('[data-open-support]')];
  const title = root.querySelector('[data-form-title]');
  const copy = root.querySelector('[data-form-copy]');
  let mode = 'recommend';
  let need = 'systems';
  let selectedProduct = '';
  let brands = [];
  let latestDetail = null;
  let actionFilter = 'all';
  let detailQuery = '';
  let showAllSystems = false;
  const visibleCounts = new Map();
  const expandedSystems = new Set();
  const productMakeListCache = new Map();
  const detailSourceCache = new Map();
  const selectorDataCache = new Map();
  let selectionMappings = [];
  let selectorRevision = 0;
  const requestTimeoutMs = 15000;
  const requestAttempts = 2;

  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const vehicleLabel = vehicle => {
    const make = String(vehicle?.makeName || '').trim();
    const model = String(vehicle?.model || '').trim();
    if (!make) return model;
    if (!model) return make;
    const makeLower = make.toLowerCase();
    const modelLower = model.toLowerCase();
    return modelLower === makeLower || modelLower.startsWith(`${makeLower} `)
      ? model
      : `${make} ${model}`;
  };
  const money = cents => new Intl.NumberFormat(root.dataset.locale || 'de-DE', {
    style:'currency',
    currency:root.dataset.currency || 'EUR'
  }).format(Number(cents || 0) / 100);
  const cleanSystemLabel=data.cleanSystemLabel;
  const coverageRecordDetail=data.coverageRecordDetail;
  const completeCoverageRecordKey=data.completeCoverageRecordKey;
  const currentVehicle = () => ({
    makeId: makeSelect.value,
    makeName: makeSelect.options[makeSelect.selectedIndex]?.text || '',
    model: modelSelect.value,
    year: yearSelect.value
  });
  const setOptions = (select, items, placeholder, objectMode = false) => {
    select.innerHTML = `<option value="">${esc(placeholder)}</option>` + items.map(item => objectMode
      ? `<option value="${esc(item.id)}">${esc(item.name)}</option>`
      : `<option value="${esc(item)}">${esc(item)}</option>`).join('');
    select.disabled = !items.length;
    select._tcvCombobox?.sync(true);
  };
  let openVehicleCombobox = null;
  let vehicleComboboxSequence = 0;
  const normalizeVehicleSearch = value => String(value || '')
    .toLocaleLowerCase("de").replace(/ß/g,"ss")
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
  const createVehicleCombobox = (select, {label, noun, placeholder, numeric = false}) => {
    const field = select.closest('.tcv__field');
    const fieldLabel = field?.querySelector('label');
    if (!field || !fieldLabel || select._tcvCombobox) return null;

    vehicleComboboxSequence += 1;
    const idBase = `${root.id}-combo-${vehicleComboboxSequence}`;
    const inputId = `${idBase}-input`;
    const listId = `${idBase}-list`;
    const combo = document.createElement('div');
    combo.className = 'tcv__combo';
    const shell = document.createElement('div');
    shell.className = 'tcv__combo-shell';
    shell.innerHTML = '<svg class="tcv__combo-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"></circle><path d="m20 20-4-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>';
    const input = document.createElement('input');
    input.id = inputId;
    input.className = 'tcv__combo-input';
    input.type = 'text';
    input.inputMode = numeric ? 'numeric' : 'search';
    input.autocomplete = 'off';
    input.spellcheck = false;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', listId);
    input.setAttribute('aria-label', `Suchen und auswählen: ${noun}`);
    const chevron = document.createElement('span');
    chevron.className = 'tcv__combo-chevron';
    chevron.setAttribute('aria-hidden', 'true');
    shell.append(input, chevron);
    combo.appendChild(shell);
    field.appendChild(combo);

    const panel = document.createElement('div');
    panel.className = 'tcv__combo-panel';
    panel.hidden = true;
    const meta = document.createElement('div');
    meta.className = 'tcv__combo-meta';
    const metaTitle = document.createElement('strong');
    metaTitle.textContent = `Auswählen: ${noun}`;
    const metaCount = document.createElement('span');
    meta.append(metaTitle, metaCount);
    const list = document.createElement('ul');
    list.id = listId;
    list.className = 'tcv__combo-list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', `Verfügbare Auswahl: ${noun}`);
    const empty = document.createElement('p');
    empty.className = 'tcv__combo-empty';
    empty.textContent = 'Keine Treffer. Versuchen Sie einen kürzeren Suchbegriff.';
    empty.hidden = true;
    const statusMessage = document.createElement('span');
    statusMessage.className = 'tcv__combo-status';
    statusMessage.setAttribute('role', 'status');
    statusMessage.setAttribute('aria-live', 'polite');
    panel.append(meta, list, empty, statusMessage);
    document.body.appendChild(panel);

    select.classList.add('tcv__combo-native');
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    fieldLabel.htmlFor = inputId;

    const state = {
      select, input, shell, panel, list, empty, metaCount, noun, placeholder,
      options: [], filtered: [], activeIndex: -1, open: false, typing: false
    };
    const selectedText = () => {
      const selected = select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
      return select.value && selected ? selected.textContent.trim() : '';
    };
    const nativePlaceholder = () => {
      const first = select.options?.[0];
      return first && !first.value ? first.textContent.trim() : placeholder;
    };
    const nativeOptions = () => [...select.options]
      .filter(option => option.value && !option.disabled)
      .map(option => ({
        value:option.value,
        label:option.textContent.trim(),
        search:normalizeVehicleSearch(option.textContent)
      }));
    const setActive = (index, shouldScroll = false) => {
      const items = [...list.querySelectorAll('.tcv__combo-option')];
      if (!items.length) {
        state.activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
        return;
      }
      state.activeIndex = Math.max(0, Math.min(index, items.length - 1));
      items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === state.activeIndex));
      const active = items[state.activeIndex];
      input.setAttribute('aria-activedescendant', active.id);
      if (shouldScroll) active.scrollIntoView({block:'nearest'});
    };
    const positionPanel = () => {
      if (!state.open) return;
      const rect = shell.getBoundingClientRect();
      const visual = window.visualViewport;
      const viewportTop = visual ? visual.offsetTop : 0;
      const viewportHeight = visual ? visual.height : window.innerHeight;
      const viewportBottom = viewportTop + viewportHeight;
      const gap = 7;
      const below = viewportBottom - rect.bottom - gap - 10;
      const above = rect.top - viewportTop - gap - 10;
      const placeBelow = below >= 210 || below >= above;
      const available = Math.max(150, Math.min(360, placeBelow ? below : above));
      const width = Math.max(220, Math.min(rect.width, window.innerWidth - 20));
      const left = Math.max(10, Math.min(rect.left, window.innerWidth - width - 10));
      panel.style.width = `${width}px`;
      panel.style.left = `${left}px`;
      panel.style.maxHeight = `${available}px`;
      panel.style.top = placeBelow ? `${rect.bottom + gap}px` : 'auto';
      panel.style.bottom = placeBelow ? 'auto' : `${window.innerHeight - rect.top + gap}px`;
    };
    const filterOptions = () => {
      const query = normalizeVehicleSearch(input.value);
      if (!query || (!state.typing && input.value === selectedText())) return state.options.slice();
      return state.options
        .filter(option => option.search.includes(query))
        .sort((a,b) => {
          const aStarts = a.search.startsWith(query) ? 0 : 1;
          const bStarts = b.search.startsWith(query) ? 0 : 1;
          return aStarts - bStarts || a.label.localeCompare(b.label, undefined, {sensitivity:'base'});
        });
    };
    const choose = option => {
      if (!option) return;
      state.typing = false;
      select.value = option.value;
      input.value = option.label;
      select.dispatchEvent(new Event('input', {bubbles:true}));
      select.dispatchEvent(new Event('change', {bubbles:true}));
      try { input.focus({preventScroll:true}); } catch (_) { input.focus(); }
      state.close(false);
    };
    const renderOptions = () => {
      state.filtered = filterOptions();
      list.replaceChildren();
      empty.hidden = Boolean(state.filtered.length);
      list.hidden = !state.filtered.length;
      metaCount.textContent = `${state.filtered.length} ${state.filtered.length === 1 ? 'Option' : 'Optionen'}`;
      statusMessage.textContent = state.filtered.length
        ? `${state.filtered.length} passende Optionen: ${noun}`
        : `Keine passenden Optionen: ${noun}`;
      state.filtered.forEach((option, index) => {
        const item = document.createElement('li');
        item.id = `${idBase}-option-${index}`;
        item.className = 'tcv__combo-option';
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', String(option.value === select.value));
        const mark = document.createElement('span');
        mark.className = 'tcv__combo-mark';
        mark.setAttribute('aria-hidden', 'true');
        const optionLabel = document.createElement('span');
        optionLabel.textContent = option.label;
        item.append(mark, optionLabel);
        item.addEventListener('pointermove', () => setActive(index));
        item.addEventListener('click', event => {
          event.preventDefault();
          choose(option);
        });
        list.appendChild(item);
      });
      const selectedIndex = state.filtered.findIndex(option => option.value === select.value);
      setActive(selectedIndex >= 0 ? selectedIndex : 0);
      positionPanel();
    };
    state.openPanel = () => {
      if (input.disabled || !state.options.length) return;
      if (openVehicleCombobox && openVehicleCombobox !== state) openVehicleCombobox.close(true);
      state.open = true;
      openVehicleCombobox = state;
      panel.hidden = false;
      shell.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
      renderOptions();
      requestAnimationFrame(positionPanel);
    };
    state.close = (revertInput = true) => {
      if (!state.open) return;
      state.open = false;
      state.typing = false;
      panel.hidden = true;
      shell.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      if (revertInput) input.value = selectedText();
      if (openVehicleCombobox === state) openVehicleCombobox = null;
      updateSubmit();
    };
    state.sync = (forceInput = false) => {
      state.options = nativeOptions();
      input.disabled = Boolean(select.disabled);
      shell.classList.toggle('is-disabled', input.disabled);
      input.placeholder = input.disabled ? nativePlaceholder() : placeholder;
      if (forceInput || !state.open || !state.typing) input.value = selectedText();
      if (state.open) renderOptions();
    };

    input.addEventListener('focus', state.openPanel);
    input.addEventListener('click', () => {
      state.openPanel();
      if (input.value && input.value === selectedText()) input.select();
    });
    input.addEventListener('input', () => {
      state.typing = true;
      invalidateQuery(); updateSubmit();
      state.openPanel();
      renderOptions();
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown') {
        event.preventDefault(); state.openPanel(); setActive(state.activeIndex + 1, true);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault(); state.openPanel(); setActive(state.activeIndex <= 0 ? state.filtered.length - 1 : state.activeIndex - 1, true);
      } else if (event.key === 'Enter' && state.open) {
        event.preventDefault(); choose(state.filtered[state.activeIndex]);
      } else if (event.key === 'Escape' && state.open) {
        event.preventDefault(); event.stopPropagation(); state.close(true);
      } else if (event.key === 'Tab') {
        state.close(true);
      }
    });
    select.addEventListener('change', () => state.sync(!state.typing));
    let observerQueued = false;
    new MutationObserver(() => {
      if (observerQueued) return;
      observerQueued = true;
      requestAnimationFrame(() => {
        observerQueued = false;
        state.sync(false);
      });
    }).observe(select, {childList:true, subtree:true, attributes:true, attributeFilter:['disabled']});
    state.position = positionPanel;
    select._tcvCombobox = state;
    state.sync(true);
    return state;
  };
  const vehicleComboboxes = [
    createVehicleCombobox(makeSelect, {label:'Marke', noun:'Marke', placeholder:'Marke suchen oder auswählen'}),
    createVehicleCombobox(modelSelect, {label:'Modell', noun:'Modell', placeholder:'Modell suchen oder auswählen'}),
    createVehicleCombobox(yearSelect, {label:'Baujahr', noun:'Baujahr', placeholder:'Baujahr suchen oder auswählen', numeric:true})
  ].filter(Boolean);
  const syncVehicleCombobox = select => select?._tcvCombobox?.sync(true);
  document.addEventListener('pointerdown', event => {
    if (!openVehicleCombobox) return;
    if (openVehicleCombobox.panel.contains(event.target) || openVehicleCombobox.input.contains(event.target)) return;
    openVehicleCombobox.close(true);
  });
  window.addEventListener('resize', () => openVehicleCombobox?.position(), {passive:true});
  window.addEventListener('scroll', () => openVehicleCombobox?.position(), {passive:true, capture:true});
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', () => openVehicleCombobox?.position(), {passive:true});
    window.visualViewport.addEventListener('scroll', () => openVehicleCombobox?.position(), {passive:true});
  }
  const updateSubmit = () => {
    const ready = makeSelect.value && modelSelect.value && yearSelect.value && (mode === 'scanner' ? selectedProduct : need);
    submit.disabled = !ready || vehicleComboboxes.some(state=>state.typing);
  };
  const showStatus = (heading, message, isError = false, action = null) => {
    status.hidden = false;
    status.classList.toggle('is-error', isError);
    status.innerHTML = `<div><strong>${esc(heading)}</strong><p>${esc(message)}</p></div>${action ? `<button type="button" data-status-action>${esc(action.label)}</button>` : ''}`;
    if (action) status.querySelector('[data-status-action]')?.addEventListener('click', action.run, {once:true});
  };
  const hideStatus = () => { status.hidden = true; status.innerHTML = ''; };
  const showRetryError = (heading, error, retry) => {
    const original=error?.message || String(error);
    const message=error?.name==='TimeoutError' ? 'Zeitüberschreitung bei der Datenquelle. Bitte erneut versuchen.'
      : /Coverage |Timed out|Failed to fetch|fetch failed/i.test(original) ? 'Die Quelle hat keine vollständigen, prüfbaren Daten geliefert. Bitte erneut versuchen. Unvollständige Daten werden nicht als Inkompatibilität ausgegeben.' : original;
    showStatus(heading, message, true, {
      label:'Erneut versuchen',
      run:() => {
        hideStatus();
        Promise.resolve()
          .then(retry)
          .catch(nextError => showRetryError(heading, nextError, retry));
      }
    });
  };
  const wait = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds));
  const fulfilledValues = (settled, label) => {
    const values = settled.filter(item => item.status === 'fulfilled').map(item => item.value);
    const failures = settled.filter(item => item.status === 'rejected');
    if (!values.length && failures.length) {
      throw failures[0].reason instanceof Error
        ? failures[0].reason
        : new Error(`${label} ist vorübergehend nicht verfügbar`);
    }
    values.partialFailureCount = failures.length;
    return values;
  };
  const withPartialFailureCount = (items, ...sources) => {
    items.partialFailureCount = sources.reduce(
      (sum, source) => sum + Number(source?.partialFailureCount || 0),
      0
    );
    return items;
  };
  const showPartialStatus = (label, count, retry) => {
    if (!count) return;
    showStatus(
      'Einige Datenquellen sind vorübergehend nicht verfügbar',
      `${count} Datenquelle(n) hat/haben nicht geantwortet. Die Liste kann unvollständig sein. Bitte erneut versuchen, bevor Sie ein Fahrzeug als fehlend einstufen.`,
      false,
      {
        label:`Erneut versuchen: ${label}`,
        run:() => {
          hideStatus();
          Promise.resolve()
            .then(retry)
            .catch(error => showRetryError(`Erneutes Laden fehlgeschlagen: ${label}`, error, retry));
        }
      }
    );
  };
  const mapWithConcurrency = async (items, limit, worker) => {
    const output = new Array(items.length);
    let nextIndex = 0;
    const run = async () => {
      while (nextIndex < items.length) {
        const index = nextIndex;
        nextIndex += 1;
        output[index] = await worker(items[index], index);
      }
    };
    await Promise.all(
      Array.from({length:Math.min(limit, items.length)}, () => run())
    );
    return output;
  };
  const mappingKey = mapping => JSON.stringify([mapping.apiName,mapping.id,mapping.pdtType,mapping.pdtAliasId]);
  const getProductMakeList = product => data.makeList(product,catalogueController?.signal);
  const usableMakeEntries = data.usable;
  const activeProductsForSelection = () => mode==='scanner'
    ? products.filter(product=>product.apiName===selectedProduct) : products;
  const invalidateQuery = () => {
    queryRevision += 1;
    queryController?.abort();
    queryController=null;
    latestDetail=null;
    results.hidden=true;
    ['coverageProduct','coverageSourceRows','coveragePages','coverageLanguage'].forEach(key=>delete root.dataset[key]);
  };
  const beginCatalogue = () => {
    catalogueController?.abort();
    catalogueController=new AbortController();
    return catalogueController.signal;
  };
  const resolveSelectionMappings = async (makeId,signal) => {
    const activeProducts=activeProductsForSelection();
    const settled=await Promise.allSettled(activeProducts.map(async product=>({product,
      sources:await data.mappings(product,makeId,signal)})));
    if(signal?.aborted)throw new DOMException('Cancelled','AbortError');
    const lists=fulfilledValues(settled, 'Markenliste');
    const mappings=new Map();
    lists.forEach(({product,sources})=>sources.forEach(source=>{
      const mapping={...source,apiName:product.apiName};
      mappings.set(mappingKey(mapping),mapping);
    }));
    return withPartialFailureCount([...mappings.values()],lists);
  };
  const loadYearsForSelection = async (preferredYear='',revision=++selectorRevision,signal=beginCatalogue()) => {
    invalidateQuery();
    setOptions(yearSelect,[],'Baujahre werden geladen…'); updateSubmit();
    if(!makeSelect.value || !modelSelect.value || !selectionMappings.length)return;
    const sources=selectionMappings.filter(mapping=>!mapping.models || mapping.models.includes(modelSelect.value));
    const settled=await Promise.allSettled(sources.map(mapping=>data.selector(mapping,2,modelSelect.value,signal)));
    if(signal.aborted || revision!==selectorRevision)return;
    const payloads=fulfilledValues(settled,'Baujahrliste');
    const years=[...new Set(payloads.flatMap(payload=>payload.data.filter(Boolean)))].sort((a,b)=>
      Number(String(b).match(/\d{4}/)?.[0]||0)-Number(String(a).match(/\d{4}/)?.[0]||0));
    setOptions(yearSelect,years,'Baujahr auswählen');
    if(preferredYear && years.includes(preferredYear)){yearSelect.value=preferredYear;syncVehicleCombobox(yearSelect);}
    const failures=Number(selectionMappings.partialFailureCount||0)+Number(payloads.partialFailureCount||0);
    if(failures)showPartialStatus('Baujahre',failures,()=>{data.clear();return loadYearsForSelection(preferredYear);});
    if(!years.length)showStatus('Baujahrdaten unvollständig','Modell- oder Baujahrdaten sind unvollständig. Das belegt keine Inkompatibilität. Senden Sie Ihre FIN an unseren Support.');
    updateSubmit();
  };
  const loadModelsForSelection = async ({preferredModel='',preferredYear='',revision=++selectorRevision,signal=beginCatalogue()}={}) => {
    invalidateQuery();
    setOptions(modelSelect,[],'Modelle werden geladen…'); setOptions(yearSelect,[],'Zuerst ein Modell wählen'); updateSubmit();
    if(!makeSelect.value)return;
    const mappings=await resolveSelectionMappings(makeSelect.value,signal);
    if(signal.aborted || revision!==selectorRevision)return;
    selectionMappings=mappings;
    if(!mappings.length){showStatus('Fahrzeugliste nicht verfügbar','Keine prüfbare Datenquelle für diese Marke und dieses Gerät gefunden. Das belegt keine Inkompatibilität.');return;}
    const settled=await Promise.allSettled(mappings.map(async mapping=>{
      const payload=await data.selector(mapping,1,'',signal); return {...mapping,models:payload.data.filter(Boolean)};
    }));
    if(signal.aborted || revision!==selectorRevision)return;
    const resolved=fulfilledValues(settled,'Modellliste');
    selectionMappings=withPartialFailureCount(resolved,mappings,resolved);
    const models=[...new Set(resolved.flatMap(mapping=>mapping.models))].sort((a,b)=>String(a).localeCompare(String(b),'de',{sensitivity:'base',numeric:true}));
    setOptions(modelSelect,models,'Modell auswählen');
    if(preferredModel && models.includes(preferredModel)){
      modelSelect.value=preferredModel;syncVehicleCombobox(modelSelect);
      await loadYearsForSelection(preferredYear,revision,signal);
    }
    if(selectionMappings.partialFailureCount)showPartialStatus('Modelle',selectionMappings.partialFailureCount,()=>{data.clear();return loadModelsForSelection({preferredModel,preferredYear});});
    if(!models.length)showStatus('Modelldaten unvollständig','Modell- und Baujahrdaten dieser Marke sind noch unvollständig. Das bedeutet nicht, dass das Gerät inkompatibel ist. Senden Sie Ihre FIN an unseren Support.');
    updateSubmit();
  };
  const loadMakesForSelection = async ({preferredMake='',preferredModel='',preferredYear='',revision=++selectorRevision}={}) => {
    const signal=beginCatalogue(); invalidateQuery(); selectionMappings=[];
    demoButton.disabled=true;
    setOptions(modelSelect,[],'Zuerst eine Marke wählen'); setOptions(yearSelect,[],'Zuerst ein Modell wählen');
    const activeProducts=activeProductsForSelection();
    if(!activeProducts.length){brands=[];setOptions(makeSelect,[],'Zuerst ein Diagnosegerät wählen');updateSubmit();return;}
    setOptions(makeSelect,[],'Marken werden geladen…');
    const settled=await Promise.allSettled(activeProducts.map(product=>data.makeList(product,signal)));
    if(signal.aborted || revision!==selectorRevision)return;
    const lists=fulfilledValues(settled,'Markenliste');
    const map=new Map();
    lists.flatMap(usableMakeEntries).forEach(item=>{
      const id=String(item.swId).trim(),key=id.toUpperCase(),name=String(item.name||item.nameEn||id).trim();
      if(!map.has(key))map.set(key,{id,name});
    });
    brands=[...map.values()].sort((a,b)=>a.name.localeCompare(b.name,'de',{sensitivity:'base'}));
    setOptions(makeSelect,brands,'Marke auswählen',true);
    demoButton.disabled=!brands.some(brand=>String(brand.id).toUpperCase()==='HONDA');
    const preserved=brands.find(brand=>brand.id.toUpperCase()===String(preferredMake).toUpperCase());
    if(preserved){makeSelect.value=preserved.id;syncVehicleCombobox(makeSelect);
      await loadModelsForSelection({preferredModel,preferredYear,revision,signal});}
    if(lists.partialFailureCount)showPartialStatus('Marken',lists.partialFailureCount,()=>{data.clear();return loadMakesForSelection({preferredMake,preferredModel,preferredYear});});
    updateSubmit();
  };
  const renderScanners = () => {
    scannersWrap.innerHTML = products.map(product => `
      <button type="button" class="tcv__scanner-choice${selectedProduct === product.apiName ? ' is-selected' : ''}" data-product="${esc(product.apiName)}" aria-pressed="${selectedProduct === product.apiName}">
        <img src="${esc(product.image)}" alt="" loading="lazy">
        <span><strong>${esc(product.name)}</strong><small>${esc(product.tier)}</small></span>
        <i class="tcv__scanner-check" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m7 12 3 3 7-7"/></svg></i>
      </button>`).join('');
  };
  const setMode = async newMode => {
    if (newMode === mode) return;
    invalidateQuery();
    const revision = ++selectorRevision;
    const preferredMake = makeSelect.value;
    const preferredModel = modelSelect.value;
    const preferredYear = yearSelect.value;
    mode = newMode;
    modeButtons.forEach(button => {
      const active = button.dataset.mode === mode;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active);
    });
    needsSection.hidden = mode !== 'recommend';
    scannerBlock.hidden = mode !== 'scanner';
    title.textContent = mode === 'scanner' ? 'Wählen Sie Ihr Diagnosegerät' : 'Starten Sie mit Ihrem Fahrzeug';
    copy.textContent = mode === 'scanner'
      ? 'Wählen Sie das THINKCAR- oder MUCAR-Gerät, das Sie prüfen möchten.'
      : 'Wählen Sie Marke, Modell und Baujahr.';
    submitLabel.textContent = mode === 'scanner' ? 'Kompatibilität prüfen' : 'Passendes Gerät finden';
    results.hidden = true;
    hideStatus();
    updateSubmit();
    try {
      await loadMakesForSelection({
        preferredMake,
        preferredModel,
        preferredYear,
        revision
      });
    } catch (error) {
      if (revision !== selectorRevision) return;
      setOptions(makeSelect, [], 'Marken nicht verfügbar');
      showRetryError('Fahrzeugliste konnte nicht geladen werden', error, () => {
        data.clear();
        selectorDataCache.clear();
        return loadMakesForSelection({preferredMake, preferredModel, preferredYear});
      });
    }
  };

  const openSupport = button => {
    let attempts = 0;
    button.disabled = true;
    button.classList.remove('is-unavailable');
    button.setAttribute('aria-busy', 'true');
    const label = button.querySelector('[data-support-label]');
    const defaultLabel = label?.textContent || 'Support kontaktieren';
    const finish = () => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    };
    const tryOpen = () => {
      const panel = document.getElementById('laykefu');
      if (panel && window.getComputedStyle(panel).display !== 'none') {
        panel.querySelector('#msg-area')?.focus();
        finish();
        return;
      }
      const launcher = document.getElementById('show-laykefu');
      if (launcher) {
        launcher.click();
        window.setTimeout(() => {
          document.querySelector('#laykefu #msg-area')?.focus();
          if (label) label.textContent = defaultLabel;
          finish();
        }, 120);
        return;
      }
      attempts += 1;
      if (attempts < 20) {
        window.setTimeout(tryOpen, 150);
        return;
      }
      if (label) label.textContent = 'Support wird geladen – bitte erneut versuchen';
      button.classList.add('is-unavailable');
      finish();
    };
    tryOpen();
  };

  modeButtons.forEach(button => button.addEventListener('click', () => {
    setMode(button.dataset.mode).catch(error => {
      showRetryError('Fahrzeugliste konnte nicht geladen werden', error, () => {
        data.clear();
        selectorDataCache.clear();
        return loadMakesForSelection();
      });
    });
  }));
  supportButtons.forEach(button => button.addEventListener('click', () => openSupport(button)));
  needButtons.forEach(button => button.addEventListener('click', () => {
    need = button.dataset.need;
    invalidateQuery(); hideStatus();
    needButtons.forEach(item => {
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected);
    });
    updateSubmit();
  }));
  scannersWrap.addEventListener('click', async event => {
    const button = event.target.closest('[data-product]');
    if (!button) return;
    invalidateQuery();
    const revision = ++selectorRevision;
    const preferredMake = makeSelect.value;
    const preferredModel = modelSelect.value;
    const preferredYear = yearSelect.value;
    selectedProduct = button.dataset.product;
    renderScanners();
    hideStatus();
    try {
      await loadMakesForSelection({
        preferredMake,
        preferredModel,
        preferredYear,
        revision
      });
    } catch (error) {
      if (revision !== selectorRevision) return;
      setOptions(makeSelect, [], 'Marken nicht verfügbar');
      showRetryError('Fahrzeugliste dieses Geräts konnte nicht geladen werden', error, () => {
        data.clear();
        selectorDataCache.clear();
        return loadMakesForSelection({preferredMake, preferredModel, preferredYear});
      });
    }
    updateSubmit();
  });

  makeSelect.addEventListener('change', async () => {
    hideStatus();
    try {
      await loadModelsForSelection();
    } catch (error) {
      if(error?.name==='AbortError')return;
      showRetryError('Modelle konnten nicht geladen werden', error, () => {
        selectorDataCache.clear();
        return loadModelsForSelection();
      });
    }
  });
  modelSelect.addEventListener('change', async () => {
    hideStatus();
    try {
      await loadYearsForSelection();
    } catch (error) {
      if(error?.name==='AbortError')return;
      showRetryError('Baujahre konnten nicht geladen werden', error, () => {
        selectorDataCache.clear();
        return loadYearsForSelection();
      });
    }
  });
  yearSelect.addEventListener('change',()=>{invalidateQuery();hideStatus();updateSubmit();});

  demoButton.addEventListener('click', async () => {
    const honda=brands.find(brand=>String(brand.id).toUpperCase()==='HONDA');
    if(!honda)return;
    demoButton.disabled=true;hideStatus();invalidateQuery();
    const revision=++selectorRevision,signal=beginCatalogue();
    try {
      makeSelect.value=honda.id;syncVehicleCombobox(makeSelect);
      await loadModelsForSelection({revision,signal});
      if(signal.aborted || revision!==selectorRevision)return;
      const models=[...modelSelect.options].map(option=>option.value).filter(Boolean);
      const demoModel=models.find(value=>String(value).toLowerCase()==='accord') || models.find(value=>/accord/i.test(value));
      if(!demoModel)throw new Error('Das Beispielfahrzeug ist für dieses Gerät nicht verfügbar. Bitte ein anderes Fahrzeug wählen.');
      modelSelect.value=demoModel;syncVehicleCombobox(modelSelect);
      await loadYearsForSelection('',revision,signal);
      if(signal.aborted || revision!==selectorRevision)return;
      const years=[...yearSelect.options].map(option=>option.value).filter(Boolean);
      yearSelect.value=years.find(value=>String(value).trim()==='1999-2015') || years.find(value=>{
        const range=String(value).match(/\d{4}/g)?.map(Number)||[];
        return range.length>1 && Math.min(...range)<=2010 && Math.max(...range)>=2010;
      }) || years[0] || '';
      syncVehicleCombobox(yearSelect);
    } catch(error) {
      if(!signal.aborted && revision===selectorRevision)showRetryError('Beispielfahrzeug konnte nicht geladen werden',error,()=>demoButton.click());
    } finally {demoButton.disabled=false;updateSubmit();}
  });

  const evaluate = async (product,vehicle,selectedNeed='systems',signal=queryController?.signal) => {
    const complete=await data.coverage(product,vehicle,signal);
    const allowed=complete.rows.filter(row=>data.rowAllowed(row,product));
    const features=allowed.filter(row=>data.isForNeed(row,selectedNeed));
    const labels={warning:'Fehlercodes und Live-Daten',active:'Aktorentests',service:'Wartung und Rückstellungen',coding:'Codierung oder Konfiguration',tpms:'RDKS-Funktionen',systems:'Funktionen je System'};
    const categories=['warning','active','service','coding','tpms'].filter(key=>allowed.some(row=>data.isForNeed(row,key)));
    const verifiedFeatures=[...new Set([selectedNeed,...categories])].filter(key=>labels[key]).map(key=>labels[key]);
    return {...product,compatible:features.length>0,vehicleCompatible:allowed.length>0,
      featureVerified:features.length>0,featureRows:features.length,total:complete.total,
      features:verifiedFeatures.slice(0,3),detailSources:complete.sources,completeCoverage:complete};
  };
  const renderRecommendation = (vehicle, checked) => {
    const compatibleByName = new Map(
      checked.filter(item => item.compatible).map(item => [item.apiName, item])
    );
    const found = salesOrder
      .map(apiName => compatibleByName.get(apiName))
      .filter(Boolean);
    const unavailable = checked.filter(item => item.compatible == null);
    results.innerHTML = `
      <div class="tcv__result-head">
        <div><p class="tcv__eyebrow">Geprüfte Fahrzeugkompatibilität</p><h2>${esc(vehicleLabel(vehicle))}</h2><p>${esc(vehicle.year)} · ${found.length} verifizierte Geräte für diese Aufgabe <span class="tcv__sort-note" title="Shopify-Nettoverkäufe vom ${esc(salesWindow.since)} bis ${esc(salesWindow.until)} – Ranking-Snapshot">Bestseller · ${esc(salesWindow.since)} / ${esc(salesWindow.until)}</span></p></div>
        <button type="button" data-edit>↑ Fahrzeug ändern</button>
      </div>
      ${unavailable.length ? `<div class="tcv__verification-warning">Prüfung derzeit nicht verfügbar für ${unavailable.map(product => esc(product.name)).join(', ')}. Diese Geräte werden nicht als inkompatibel eingestuft. Bitte erneut versuchen.</div>` : ''}
      ${found.length ? `<div class="tcv__cards">${found.map(product => `
        <article class="tcv__card">
          <div class="tcv__card-media"><span class="tcv__tier">${esc(product.tier)}</span><img src="${esc(product.image)}" alt="${esc(product.name)}" loading="lazy"></div>
          <div class="tcv__card-body">
            <div class="tcv__card-top"><h3>${esc(product.name)}</h3><span class="tcv__price">${money(product.price)}</span></div>
            <p>${esc(product.summary)}</p>
            <div class="tcv__verified">✓ Fahrzeug und Funktion geprüft · ${product.total.toLocaleString()} Datensätze</div>
            <p class="tcv__verified-feature-label">Geprüfte Funktionen für dieses Fahrzeug:</p><ul class="tcv__features">${product.features.map(feature => `<li>${esc(feature)}</li>`).join('')}</ul>
            <div class="tcv__card-actions">
              <button type="button" data-exact-product="${esc(product.apiName)}">Genaue Funktionen</button>
              <a href="${esc(product.url)}">Zum Produkt →</a>
            </div>
          </div>
        </article>`).join('')}</div>` : `<div class="tcv__empty"><h3>Kein Gerät für diese Aufgabe verifiziert</h3><p>Senden Sie vor dem Kauf Ihre FIN und die benötigte Funktion an unseren Support.</p></div>`}`;
    results.hidden = false;
    results.querySelector('[data-edit]').addEventListener('click', () => root.querySelector('.tcv__finder').scrollIntoView({behavior:'smooth'}));
    results.querySelectorAll('[data-exact-product]').forEach(button => button.addEventListener('click', async () => {
      const product = found.find(item => item.apiName === button.dataset.exactProduct);
      if (!product) return;
      const detailRevision=queryRevision;
      showStatus('Genaue Funktionen werden geladen…', `Alle Datensätze für ${product.name} werden geprüft.`);
      try {
        const detail=await fetchDetails(product, vehicle);
        if(detailRevision!==queryRevision)return;
        latestDetail=detail;
        actionFilter = 'all'; detailQuery = ''; showAllSystems = false; visibleCounts.clear(); expandedSystems.clear();
        renderDetails(product, vehicle);
        hideStatus();
        results.scrollIntoView({behavior:'smooth', block:'start'});
      } catch (error) {
        if(detailRevision!==queryRevision)return;
        showRetryError('Genaue Funktionen konnten nicht geladen werden', error, async () => {
          detailSourceCache.clear();
          const detail=await fetchDetails(product, vehicle);
        if(detailRevision!==queryRevision)return;
        latestDetail=detail;
          actionFilter = 'all'; detailQuery = ''; showAllSystems = false; visibleCounts.clear(); expandedSystems.clear();
          renderDetails(product, vehicle);
          results.scrollIntoView({behavior:'smooth', block:'start'});
        });
      }
    }));
  };
  const organizeDetailSource = (detailSource,product) => {
    const unique=new Map();
    detailSource.rows.filter(row=>row && (row.system || row.function || row.subFunction) && data.rowAllowed(row,product))
      .forEach(row=>unique.set(data.completeCoverageRecordKey(row),row));
    const groups=new Map();
    [...unique.values()].forEach(row=>{
      const system=data.cleanSystemLabel(row.system),action=String(row.function||row.subFunction||'Verfügbar');
      if(!groups.has(system))groups.set(system,[]);
      groups.get(system).push({action,detail:data.coverageRecordDetail(row,action)});
    });
    const grouped=[...groups.entries()].map(([system,entries])=>({system,entries})).sort((a,b)=>a.system.localeCompare(b.system,'de',{numeric:true,sensitivity:'base'}));
    return {total:unique.size,sourceTotal:detailSource.total,returned:unique.size,groups:grouped,
      pagesFetched:detailSource.pagesFetched,languages:detailSource.languages,englishFallback:detailSource.englishFallback,
      sourceApiName:product.apiName,richness:unique.size};
  };
  const fetchDetails = async (product,vehicle) => {
    const complete=product.completeCoverage || await data.coverage(product,vehicle,queryController?.signal);
    const detail=organizeDetailSource(complete,product);
    if(detail.total<=0)throw new Error('Keine prüfbaren Detaildaten für diese Auswahl verfügbar.');
    return detail;
  };
  const buildDetailView = () => {
    const actionCounts = new Map();
    latestDetail.groups.forEach(group => group.entries.forEach(entry =>
      actionCounts.set(entry.action, (actionCounts.get(entry.action) || 0) + 1)
    ));
    const allCount = [...actionCounts.values()].reduce((sum, value) => sum + value, 0);
    const query = detailQuery.trim().toLowerCase();
    const filtered = latestDetail.groups.map(group => ({
      ...group,
      systemMatches:Boolean(query && group.system.toLowerCase().includes(query)),
      entries:group.entries.filter(entry =>
        (actionFilter === 'all' || entry.action === actionFilter) &&
        (!query || `${group.system} ${entry.action} ${entry.detail}`.toLowerCase().includes(query))
      )
    })).filter(group => group.entries.length).sort((a,b) => {
      if (query && a.systemMatches !== b.systemMatches) return a.systemMatches ? -1 : 1;
      if (query || actionFilter !== 'all') {
        const countDifference = b.entries.length - a.entries.length;
        if (countDifference) return countDifference;
      }
      return a.system.localeCompare(b.system, undefined, {sensitivity:'base'});
    });
    const filtersActive = actionFilter !== 'all' || Boolean(query);
    const systemLimit = 12;
    const visibleGroups = showAllSystems || filtersActive ? filtered : filtered.slice(0, systemLimit);
    const visibleFunctionCount = filtered.reduce((sum, group) => sum + group.entries.length, 0);
    const chevron = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7 9 5 5 5-5"/></svg>';
    return {
      actionCounts,
      allCount,
      filtered,
      filtersActive,
      systemLimit,
      visibleGroups,
      visibleFunctionCount,
      chevron
    };
  };
  const detailSystemsMarkup = view => {
    const {visibleGroups, chevron} = view;
    if (!visibleGroups.length) {
      return '<div class="tcv__empty"><h4>Keine passenden Funktionen</h4><p>Suchen Sie nach einem anderen Begriff oder wählen Sie Alle Funktionen.</p></div>';
    }
    return visibleGroups.map((group, groupIndex) => {
      const open = expandedSystems.has(group.system);
      const actionGroups = [...group.entries.reduce((map, entry) => {
        if (!map.has(entry.action)) map.set(entry.action, []);
        map.get(entry.action).push(entry);
        return map;
      }, new Map()).entries()].map(([action, entries]) => ({action, entries}));
      return `<article class="tcv__system${open ? ' is-open' : ''}">
        <button type="button" data-system="${esc(group.system)}" aria-expanded="${open}">
          <span class="tcv__system-index">${String(groupIndex + 1).padStart(2,'0')}</span>
          <span class="tcv__system-copy"><strong>${esc(group.system)}</strong><small>${group.entries.length} Funktionen · ${actionGroups.length} ${actionGroups.length === 1 ? 'Funktionsart' : 'Funktionsarten'}</small></span>
          <span class="tcv__system-toggle">${open ? 'Ausblenden' : 'Funktionen anzeigen'}${chevron}</span>
        </button>
        ${open ? `<div class="tcv__capability-groups">${actionGroups.map(actionGroup => {
          const groupKey = `${group.system}::${actionGroup.action}`;
          const shown = visibleCounts.get(groupKey) || 6;
          const visibleEntries = actionGroup.entries.slice(0, shown);
          const remaining = actionGroup.entries.length - visibleEntries.length;
          return `<section class="tcv__capability-group">
            <div class="tcv__capability-head"><span class="tcv__capability-check">✓</span><span><strong>${esc(actionGroup.action)}</strong><small>${actionGroup.entries.length} ${actionGroup.entries.length === 1 ? 'unterstützte Funktion' : 'unterstützte Funktionen'}</small></span></div>
            <ul class="tcv__system-list">${visibleEntries.map((entry, entryIndex) => `<li><span class="tcv__function-index">${String(entryIndex + 1).padStart(2,'0')}</span><strong>${esc(entry.detail || entry.action)}</strong></li>`).join('')}</ul>
            ${actionGroup.entries.length > 6 ? `<div class="tcv__capability-actions">${remaining > 0 ? `<button type="button" class="tcv__more" data-more="${esc(groupKey)}">Weitere ${Math.min(20,remaining)} anzeigen</button>` : '<span></span>'}${shown > 6 ? `<button type="button" class="tcv__fewer" data-fewer="${esc(groupKey)}">Weniger anzeigen</button>` : ''}</div>` : ''}
          </section>`;
        }).join('')}</div>` : ''}
      </article>`;
    }).join('');
  };
  const detailSystemActionsMarkup = view => {
    const {filtered, filtersActive, systemLimit, visibleGroups, chevron} = view;
    if (filtersActive || filtered.length <= systemLimit) return '';
    return `<div class="tcv__system-list-actions"><p>${showAllSystems ? `Alle ${filtered.length} Systeme werden angezeigt.` : `${visibleGroups.length} von ${filtered.length} Systemen angezeigt.`}</p><button type="button" data-systems-toggle aria-expanded="${showAllSystems}">${showAllSystems ? 'Weniger Systeme anzeigen' : `Alle ${filtered.length} Systeme anzeigen`}${chevron}</button></div>`;
  };
  const bindDetailSystemControls = (product, vehicle) => {
    results.querySelectorAll('[data-system]').forEach(button => button.addEventListener('click', () => {
      const name = button.dataset.system;
      expandedSystems.has(name) ? expandedSystems.delete(name) : expandedSystems.add(name);
      renderDetails(product, vehicle);
    }));
    results.querySelectorAll('[data-more]').forEach(button => button.addEventListener('click', () => {
      const key = button.dataset.more;
      visibleCounts.set(key, (visibleCounts.get(key) || 6) + 20);
      renderDetails(product, vehicle);
    }));
    results.querySelectorAll('[data-fewer]').forEach(button => button.addEventListener('click', () => {
      visibleCounts.set(button.dataset.fewer, 6);
      renderDetails(product, vehicle);
    }));
    const systemsToggle = results.querySelector('[data-systems-toggle]');
    if (systemsToggle) systemsToggle.addEventListener('click', () => {
      showAllSystems = !showAllSystems;
      renderDetails(product, vehicle);
    });
  };
  const refreshDetailMatches = (product, vehicle) => {
    const view = buildDetailView();
    const summary = results.querySelector('[data-detail-summary]');
    const matchCount = results.querySelector('[data-detail-match-count]');
    const systems = results.querySelector('[data-detail-systems]');
    const systemActions = results.querySelector('[data-detail-system-actions]');
    if (!summary || !matchCount || !systems || !systemActions) return;
    summary.textContent = `${view.filtered.length} Systeme · ${view.visibleFunctionCount} Funktionen`;
    matchCount.textContent = `${view.visibleFunctionCount} von ${view.allCount} Funktionen gefunden`;
    systems.innerHTML = detailSystemsMarkup(view);
    systemActions.innerHTML = detailSystemActionsMarkup(view);
    bindDetailSystemControls(product, vehicle);
  };
  const renderDetails = (product, vehicle) => {
    root.dataset.coverageProduct=product.apiName; root.dataset.coverageSourceRows=String(latestDetail.sourceTotal);
    root.dataset.coveragePages=String(latestDetail.pagesFetched);root.dataset.coverageLanguage=(latestDetail.languages||[]).join(',');
    const view = buildDetailView();
    const {actionCounts, allCount, filtered, visibleFunctionCount} = view;
    results.innerHTML = `
      <div class="tcv__result-head">
        <div><p class="tcv__eyebrow">Funktionen für Ihr Fahrzeug</p><h2>${esc(vehicleLabel(vehicle))}</h2><p>${esc(vehicle.year)} · Genaue Funktionen für ${esc(product.name)}</p></div>
        <button type="button" data-edit>↑ Fahrzeug ändern</button>
      </div>
      <section class="tcv__report">
        <div class="tcv__report-head"><div><h3>${esc(product.name)}</h3><p>${esc(vehicleLabel(vehicle))} · ${esc(vehicle.year)}</p></div><span class="tcv__found">✓ Fahrzeugdaten gefunden</span></div>
        <div class="tcv__metrics">
          <div class="tcv__metric"><strong>${latestDetail.sourceTotal.toLocaleString()}</strong><span>Datensätze geprüft</span></div>
          <div class="tcv__metric"><strong>${latestDetail.groups.length}</strong><span>Systeme</span></div>
          <div class="tcv__metric"><strong>${actionCounts.size}</strong><span>Funktions&shy;arten</span></div>
        </div>
        ${latestDetail.englishFallback ? `<p class="tcv__language-note" role="status">Die deutsche Quelle liefert für diese Auswahl keine vollständigen Daten. Die vollständigen englischen Daten werden ohne automatische Übersetzung angezeigt.</p>` : ''}
        <div class="tcv__explorer">
          <div class="tcv__explorer-heading">
            <div><h3>Verfügbare Funktionen entdecken</h3><p>Wählen Sie eine Funktionsart und öffnen Sie das gewünschte System.</p></div>
            <span data-detail-summary>${filtered.length} Systeme · ${visibleFunctionCount} Funktionen</span>
          </div>
          <div class="tcv__capabilities">
            <button type="button" data-action="all" class="${actionFilter === 'all' ? 'is-active' : ''}">Alle Funktionen <small>${allCount}</small></button>
            ${[...actionCounts.entries()].sort((a,b) => b[1]-a[1]).map(([name,count]) => `<button type="button" data-action="${esc(name)}" class="${actionFilter === name ? 'is-active' : ''}">${esc(name)} <small>${count}</small></button>`).join('')}
          </div>
          <div class="tcv__search">
            <label><span>Funktion suchen</span><input type="search" data-function-search value="${esc(detailQuery)}" placeholder="Batterie, Injektor, DPF…" aria-label="Alle verfügbaren Funktionen durchsuchen"></label>
            <p data-detail-match-count aria-live="polite">${visibleFunctionCount} von ${allCount} Funktionen gefunden</p>
          </div>
          <div class="tcv__systems" data-detail-systems>${detailSystemsMarkup(view)}</div>
          <div data-detail-system-actions>${detailSystemActionsMarkup(view)}</div>
          ${latestDetail.sourceTotal > latestDetail.returned ? `<p class="tcv__data-note">Alle ${latestDetail.sourceTotal.toLocaleString()} Quelldatensätze wurden geladen. Nach Zusammenfassung identischer Duplikate bleiben ${latestDetail.returned.toLocaleString()} eindeutige Funktionen verfügbar.</p>` : ''}
        </div>
      </section>`;
    results.hidden = false;
    results.querySelector('[data-edit]').addEventListener('click', () => root.querySelector('.tcv__finder').scrollIntoView({behavior:'smooth'}));
    results.querySelectorAll('[data-action]').forEach(button => button.addEventListener('click', () => {
      actionFilter = button.dataset.action; showAllSystems = false; visibleCounts.clear(); renderDetails(product, vehicle);
    }));
    results.querySelector('[data-function-search]').addEventListener('input', event => {
      detailQuery = event.target.value; showAllSystems = false;
      if (root._tcvSearchFrame) cancelAnimationFrame(root._tcvSearchFrame);
      root._tcvSearchFrame = requestAnimationFrame(() => {
        root._tcvSearchFrame = null;
        refreshDetailMatches(product, vehicle);
      });
    });
    bindDetailSystemControls(product, vehicle);
  };

  form.addEventListener('submit', async event => {
    event.preventDefault();if(submit.disabled)return;
    const vehicle=currentVehicle(),requestMode=mode,requestNeed=need,requestProduct=selectedProduct;
    invalidateQuery(); const revision=queryRevision;
    const controller=new AbortController();queryController=controller;
    showStatus('Kompatibilität wird geprüft…','Alle Datenseiten für dieses Fahrzeug werden geladen.');submit.disabled=true;
    try {
      if(requestMode==='recommend'){
        const candidates=products.filter(product=>!(product.hiddenForNeeds||[]).includes(requestNeed));
        const checked=await mapWithConcurrency(candidates,2,async product=>{
          try{return await evaluate(product,vehicle,requestNeed,controller.signal);}
          catch(error){if(controller.signal.aborted)throw error;return {...product,compatible:null,serviceUnavailable:true,error:error.message};}
        });
        if(controller.signal.aborted || revision!==queryRevision)return;
        renderRecommendation(vehicle,checked);
      } else {
        const source=products.find(product=>product.apiName===requestProduct);
        const checked=await evaluate(source,vehicle,'systems',controller.signal);
        if(controller.signal.aborted || revision!==queryRevision)return;
        if(!checked.compatible){
          results.innerHTML=`<div class="tcv__result-head"><div><p class="tcv__eyebrow">Ergebnis für Ihr Diagnosegerät</p><h2>${esc(vehicleLabel(vehicle))}</h2><p>${esc(vehicle.year)} · ${esc(source.name)}</p></div></div><div class="tcv__empty"><h3>Keine genauen Fahrzeugdaten gefunden</h3><p>Die deutsche und die englische Quelle wurden geprüft. Dieses Ergebnis belegt keine Inkompatibilität. Senden Sie Ihre FIN und die benötigte Funktion an unseren Support.</p></div>`;
          results.hidden=false;
        } else {
          latestDetail=await fetchDetails(checked,vehicle);
          actionFilter='all';detailQuery='';showAllSystems=false;visibleCounts.clear();expandedSystems.clear();
          renderDetails(checked,vehicle);
        }
      }
      hideStatus();results.scrollIntoView({behavior:'smooth',block:'start'});
    } catch(error){
      if(!controller.signal.aborted && revision===queryRevision)showRetryError('Fahrzeugprüfung nicht abgeschlossen',error,()=>{data.clear();form.requestSubmit();});
    } finally { if(revision===queryRevision)updateSubmit(); }
  });

  renderScanners();
  (async () => {
    try {
      await loadMakesForSelection();
    } catch (error) {
      setOptions(makeSelect, [], 'Marken nicht verfügbar');
      showRetryError('Fahrzeugliste konnte nicht geladen werden', error, () => {
        data.clear();
        selectorDataCache.clear();
        return loadMakesForSelection();
      });
    }
  })();
})();
